export default __webpack_public_path__ + "static/media/strasbourg3.94a4ea01.jpg";